import { render, staticRenderFns } from "./Iso.vue?vue&type=template&id=7b40ad3a&scoped=true&"
import script from "./Iso.vue?vue&type=script&lang=js&"
export * from "./Iso.vue?vue&type=script&lang=js&"
import style0 from "./Iso.vue?vue&type=style&index=0&id=7b40ad3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b40ad3a",
  null
  
)

export default component.exports